import { render, staticRenderFns } from "./AdminApplicationsList.vue?vue&type=template&id=12cf994f&scoped=true"
import script from "./AdminApplicationsList.vue?vue&type=script&lang=js"
export * from "./AdminApplicationsList.vue?vue&type=script&lang=js"
import style0 from "./AdminApplicationsList.vue?vue&type=style&index=0&id=12cf994f&prod&lang=scss&scoped=true"
import style1 from "./AdminApplicationsList.vue?vue&type=style&index=1&id=12cf994f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf994f",
  null
  
)

export default component.exports